import clsx from 'clsx'

let VkIcon = ({ className }: { className?: string }) => (
  <svg
    className={clsx(className)}
    width='34'
    height='34'
    viewBox='0 0 34 34'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width="34" height="34" rx="6" fill="#0077FF"/>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18.0916 24.4943C10.3424 24.4943 5.92245 19.1818 5.73828 10.3418H9.61993C9.74743 16.8301 12.609 19.5784 14.8757 20.1451V10.3418H18.5308V15.9376C20.7692 15.6968 23.1205 13.1468 23.9139 10.3418H27.569C26.9598 13.7985 24.4098 16.3484 22.5965 17.3968C24.4098 18.2468 27.3141 20.471 28.4191 24.4943H24.3957C23.5315 21.8026 21.3783 19.7201 18.5308 19.4368V24.4943H18.0916Z'
      fill='white'
    />
  </svg>
)

export default VkIcon
